/* eslint-disable no-console */
/* eslint-disable no-undef */
export const ddoInit = (ddo) => {
  if (window._T && typeof window._T.sendPageDataToAnalytics !== 'undefined') {
    window._T.sendPageDataToAnalytics(ddo);
  } else {
    window._T = window._T || {};
    window._T.pageData = window._T.pageData || [];
    window._T.pageData.push(ddo || window.digitalData);
  }
};

export const ddoEventInit = (eventObj, IsConsoleDebug = window?.settings?.isConsoleDebug) => {
  if (window._T && typeof window._T.sendEventDataToAnalytics !== 'undefined') {
    window._T.sendEventDataToAnalytics(eventObj);

    if (IsConsoleDebug) {
      console.log('Sent Omniture Event: ' + JSON.stringify(eventObj));
    }
  } else {
    window._T = window._T || {};
    window._T.eventData = window._T.eventData || [];
    window._T.eventData.push(eventObj);
    if (console && console.log) {
      console.log('window._T undefined. Attempting to publish:' + JSON.stringify(eventObj));
    }
  }
};
